import React from 'react';

/**
 * Top-level error boundary so a render error in one view shows a friendly
 * message instead of a blank white screen.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('Uncaught error:', error, info);
    }

    handleReload = () => {
        this.setState({ hasError: false });
        window.location.assign('/');
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="container text-center mt-5">
                    <h2>Coś poszło nie tak</h2>
                    <p className="text-muted">
                        Wystąpił nieoczekiwany błąd. Spróbuj odświeżyć stronę.
                    </p>
                    <button className="btn btn-primary" onClick={this.handleReload}>
                        Wróć na stronę główną
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
